const animation = {
  v: "5.7.4",
  fr: 29.9700012207031,
  ip: 0,
  op: 49.0000019958109,
  w: 1080,
  h: 1080,
  nm: "lock color",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "bold Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 6,
              s: [540, 652.75, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 10,
              s: [540, 572.75, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.167, y: 0.167 },
              t: 12,
              s: [540, 652.75, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 32,
              s: [540, 652.75, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 36,
              s: [540, 572.75, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 38.0000015477717, s: [540, 652.75, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [145.75, 121.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [167, 167, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [9.619, -5.609],
                    [0, 0],
                    [8.94, 0],
                    [0, 8.924],
                    [0, 0],
                    [0, 11.915],
                    [-17.832, 0],
                    [0, -17.832],
                  ],
                  o: [
                    [0, 0],
                    [0, 8.924],
                    [-8.94, 0],
                    [0, 0],
                    [-9.62, -5.609],
                    [0, -17.832],
                    [17.832, 0],
                    [0, 11.915],
                  ],
                  v: [
                    [16.167, 3.589],
                    [16.167, 40.417],
                    [0, 56.583],
                    [-16.166, 40.417],
                    [-16.166, 3.589],
                    [-32.333, -24.25],
                    [0, -56.583],
                    [32.333, -24.25],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [64.667, -121.25],
                    [-64.666, -121.25],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 2,
              ty: "sh",
              ix: 3,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, -20.063],
                    [0, 0],
                    [-20.047, 0],
                    [0, 0],
                    [0, 20.063],
                    [0, 0],
                    [20.047, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-20.047, 0],
                    [0, 0],
                    [0, 20.063],
                    [0, 0],
                    [20.047, 0],
                    [0, 0],
                    [0, -20.063],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-97, -121.25],
                    [-109.125, -121.25],
                    [-145.5, -84.875],
                    [-145.5, 84.875],
                    [-109.125, 121.25],
                    [109.125, 121.25],
                    [145.5, 84.875],
                    [145.5, -84.875],
                    [109.125, -121.25],
                    [97, -121.25],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: "Path 3",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 1,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [145.75, 121.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 5,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 149.850006103516,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Layer 3 Outlines",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 10,
              s: [65.24, 75.998, 0],
              to: [0, -7.984, 0],
              ti: [0, 7.984, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 12,
              s: [65.24, 28.094, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 36,
              s: [65.24, 28.094, 0],
              to: [0, 7.984, 0],
              ti: [0, -7.984, 0],
            },
            { t: 38.0000015477717, s: [65.24, 75.998, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [100, 290.766, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [44.402, 0],
                    [0, -44.402],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, -44.402],
                    [-44.402, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [80.51, 15.383],
                    [80.51, -14.872],
                    [0, -95.383],
                    [-80.51, -14.872],
                    [-80.51, 95.383],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 40, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [180.51, 195.383], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 149.850006103516,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};
export default animation;
